import { PodcastTemplateConfig } from 'redux/middleware/api/podcast-service';
import measurement from 'utils/measurement';
import { TimerState } from '../types';

export const getTimer = (config: PodcastTemplateConfig): TimerState => {
  const { timer } = config;

  if (!timer?.length) {
    return undefined;
  }

  const { enabled, containerStyle, position } = timer[0];

  return {
    color: containerStyle.color,
    enabled,
    fontSize: measurement(containerStyle.fontSize),
    position: {
      top: measurement(position.properties.top),
      left: measurement(position.properties.left),
    },
    timerSize: {
      height: measurement(containerStyle.height),
      width: measurement(containerStyle.width),
    },
  };
};
